import {Component, Input} from "@angular/core";
import {IAction} from "../../definitions";
import {GO_ACTION_TYPES_LIST, GO_ACTION_TYPES} from "../../enums/e-game-objects";
import {VALUE_TYPE} from "../../enums/enums";
import {UI_TEXTS} from "../../enums/e-texts";
import {JP} from "../../helpers/jp";


@Component({
    selector: "nv-action",
    templateUrl: "./nv-action.component.html"
})


export class NvActionComponent {
    GO_ACTION_TYPES_LIST = GO_ACTION_TYPES_LIST;
    GO_ACTION_TYPES = GO_ACTION_TYPES;
    VALUE_TYPE = VALUE_TYPE;
    UI_TEXTS = UI_TEXTS;

    @Input() document:IAction;


    constructor() {
    }

    onItemSelected(e)
    {
      /*console.log(this.document.type);
      if (this.document.type != GO_ACTION_TYPES.EAT_LevelUp_MC || this.document.type != GO_ACTION_TYPES.EAT_LevelUp)
      {
        JP.remove(this.document, '/levelChange');
      }*/
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-actions/nv-action.component.ts